import { BaseDto } from './base.dto';
import { RoleComponentDto } from './roleComponent.dto';
import { UserRoleMerchantDto } from './userRoleMerchant.dto';
import { UserRoleDto } from './userRole.dto';
import { MerchantGroupDto } from './merchantGroup.dto';

export class UserDto extends BaseDto {
  userName: string;
  password?: string;
  email?: string;
  userRoleId?: number;
  userRole?: UserRoleDto;
  startDate?: Date;
  endDate?: Date;
  lastSeen?: Date;
  enabled?: boolean;
  merchantGroupId?: number;
  merchantGroup?: MerchantGroupDto;
  components?: RoleComponentDto[];
  role?: string;
  isAuthMigrated?: boolean;
  profileImageURL?: string;
  needsOnboarding?: boolean;
  userMerchants?: UserRoleMerchantDto[];
  isSystemUser?: boolean;
}
